/*!
 *
 *	linker.js
 *
 */

var linker = {
	init: function(options){
		this.settings = {
			icon: {
				blank: 'blank',
				excel: 'xls',
				word: 'doc',
				pdf: 'pdf'
			},
			blankDir : [],
			extendLink: '.extend-link'
		};
		var opt = options || {};
		this.settings = $.extend( this.settings, opt );
		this.domain = document.domain;
		this.set();
	},
	set : function(){
		var self = this;
		$(this.target()).each(function(){
			self.setIcon( this );
		});

		$(document).delegate('a', 'tap', function(e){
			if( $(this).is( self.target() ) ){
				e.preventDefault();
				var _href = $(this).attr('href');
				window.open( _href,'_blank');
			};
		});

		$( this.settings.extendLink ).on('tap', function(e){
			e.preventDefault();
			var _href = $(this).find('a').attr('href'),
				_target = $(this).find('a').attr('target');
			if( _target === undefined ){
				_target = '_self';
			};
			window.open( _href, _target);
		});
	},
	target : function(){
		var _target = '';
		_target =	'a[target="_blank"],'+
					'a[href^="http://"]:not([href*="'+ this.domain +'/"]),'+
					'a[href^="https://"]:not([href*="'+ this.domain +'/"]),'+
					this.blankDirectories()+
					'a[href*=".pdf"],'+
					'a[href*=".xls"], a[href*=".xlsx"],'+
					'a[href*=".doc"], a[href*=".docx"]';
		return _target;
	},
	blankDirectories : function(){
		var tg = '',
			len = this.settings.blankDir.length;
		for( var i = -1; ++i < len; ){
			var _c = ',';
			tg += 'a[href *= "'+ this.domain + '/' +this.settings.blankDir[i] +'/"]' + _c;
		};
		return tg;
	},
	setIcon : function( _this ){
		var self = this,
			href = $(_this).attr('href');
		if( !$(_this).is('.without-icon') ){
			if( href.search(/\.pdf/) > -1 ){
				$(_this).addClass( self.settings.icon.pdf );
			}else if( href.search(/\.xls/) > -1 || href.search(/\.xlsx/) > -1 ){
				$(_this).addClass( self.settings.icon.excel )
			}else if( href.search(/\.doc/) > -1 || href.search(/\.docx/) > -1 ){
				$(_this).addClass( self.settings.icon.word );
			}else{
				$(_this).addClass( self.settings.icon.blank );
			};
		};
	}
};

module.exports = linker;


//////////////////
// WEBPACK FOOTER
// ./dev/js/module/linker.js
// module id = 11
// module chunks = 0